import {createApi} from "@reduxjs/toolkit/query/react"
import {
    ReviewDetailedRequest,
    ReviewDetailedResponse,
    ReviewListRequest,
    ReviewListResponse,
    ReviewStatisticsRequest,
    ReviewStatisticsResponse
} from "./ReviewApiTypes"
import baseQuery from "../../utils/apiIIKOConfig"

export const reviewsApi = createApi({
    reducerPath: "reviewsApi",
    baseQuery,
    endpoints: (builder) => ({
        getReviews: builder.query<ReviewListResponse, ReviewListRequest>({
            query: (body) => ({
                url: "v1/reviews/list",
                method: "POST",
                body
            })
        }),
        getReviewStatistics: builder.query<ReviewStatisticsResponse, ReviewStatisticsRequest>({
            query: (body) => ({
                url: "v1/reviews/statistics",
                method: "POST",
                body
            })
        }),
        getReviewDetailed: builder.query<ReviewDetailedResponse, ReviewDetailedRequest>({
            query: ({id}) => ({
                url: `v1/reviews/${id}/detailed`,
                method: "GET",
            })
        })
    })
})

export const {useGetReviewsQuery, useGetReviewStatisticsQuery, useLazyGetReviewDetailedQuery} = reviewsApi
